import { ReactNode, CSSProperties } from "react";

import styles from "./styles.module.css";

type ThemedLogsContentProps = {
  children: ReactNode;
  style?: CSSProperties;
};

const ThemedLogsContent = ({ children, style }: ThemedLogsContentProps) => {
  return (
    <pre className={styles.logs} tabIndex={-1} style={style}>
      {children}
    </pre>
  );
};

export default ThemedLogsContent;
